const redirects={
    "c":"https://job.chikyujin.jp",
    "job":"JobPartner",
    "insurance":"Insurances",
    "remittance":"Remittance",
    "education":"Education",
    "shopping":"Shopping",
    "mobile":"Mobile",
    "estate":"Estate",
    "enter":"Entertainment",
    "travel":"Travel",
    "game":"Game",
    "corpo":"Corporate",
    "freelance":"Freelance",
    "donation":"Donation",
    "campaign":"Campaign"
};

module.exports={redirects};
